import { useState } from 'react';
import { Button } from '@ewf/components/Button';
import { ModalContainer } from '@ewf/components/ModalUI/ModalContainer';
import { GoBackButton } from '@ewf/components/ModalUI/GoBackButton';
import { CloseButton } from '@ewf/components/ModalUI/CloseButton';
import { WalletSelector, type Wallet } from '@ewf/components/ModalUI/WalletSelector';
import { Stepper } from '@ewf/components/ModalUI/Stepper';
import { LIFTING_CHAINS } from '@shared/types/enums';

export const SelectWallet = ({ onNext, onClose, network, goBack }: Props): JSX.Element => {
  const [wallet, setWallet] = useState<Wallet>('wallet-connect');

  return (
    <ModalContainer>
      <section className="mb-8 flex justify-between">
        <GoBackButton onClick={goBack} />
        <CloseButton onClick={onClose} />
      </section>
      <section className="mb-8">
        <Stepper step={1} maxStep={3} />
      </section>
      <section className="mb-8">
        <WalletSelector selectedWallet={wallet} setSelectedWallet={setWallet} network={network} />
      </section>
      <section className="flex justify-center">
        <Button onClick={() => onNext(wallet)}>Connect</Button>
      </section>
    </ModalContainer>
  );
};

interface Props {
  onClose: () => void;
  onNext: (wallet: Wallet) => void;
  network: LIFTING_CHAINS;
  goBack: () => void;
}
